import React from "react";
import { Plus, Trash2 } from "lucide-react";

export function TramosEditor({ tramos, onChange }) {
  const rows = tramos || [];
  const set = (i, k, v) => onChange(rows.map((t, j) => (j === i ? { ...t, [k]: v === "" ? "" : Number(v) } : t)));
  const add = () => {
    const last = rows[rows.length - 1];
    onChange([...rows, { supera: last ? Number(last.supera) + 5 : 5, cobro: last ? Number(last.cobro) : 20 }]);
  };
  return (
    <div className="mb-5" data-testid="tramos-editor">
      <div className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1">Tramos de cobro</div>
      <p className="text-xs text-slate-500 mb-2">Solo se cobra si se supera el objetivo. Cada indicador cobra el % de su parte del tramo más alto alcanzado.</p>
      <div className="flex flex-wrap gap-2 items-end">
        {rows.map((t, i) => (
          <div key={i} className="flex items-center gap-1 rounded-lg border border-slate-200 px-1.5 py-1.5 text-xs max-w-full" data-testid={`tramo-${i}`}>
            <span className="text-slate-500 whitespace-nowrap">Supera +</span>
            <input type="number" min={0} step={1} value={t.supera} onChange={(e) => set(i, "supera", e.target.value)}
                   className="input text-xs text-right" style={{ width: 50, padding: "4px 6px" }} data-testid={`tramo-supera-${i}`} />
            <span className="text-slate-500 whitespace-nowrap">% → cobra</span>
            <input type="number" min={0} step={5} value={t.cobro} onChange={(e) => set(i, "cobro", e.target.value)}
                   className="input text-xs text-right" style={{ width: 58, padding: "4px 6px" }} data-testid={`tramo-cobro-${i}`} />
            <span className="text-slate-500">%</span>
            <button type="button" onClick={() => onChange(rows.filter((_, j) => j !== i))} title="Quitar tramo"
                    className="p-1 text-slate-400 hover:text-red-600" data-testid={`tramo-quitar-${i}`}><Trash2 size={13} /></button>
          </div>
        ))}
        <button type="button" onClick={add} disabled={rows.length >= 12} className="btn btn-outline btn-sm" data-testid="tramo-add"><Plus size={13} /> Añadir tramo</button>
      </div>
    </div>
  );
}
